import React from 'react';
import ReactHtmlParser from 'react-html-parser';
const NeedToKnow = ({EQReturnData, Open}) => {
    return (
        <ul className="tiny-flex-grid-1 medium-flex-grid-2" key="ntk">
            <li className="w_return-policy" key="ntklist">
                <div className="bg-white shadow">
                    <div className="return-policy_title">{EQReturnData.ntklist[0].title}</div>
                    <div className="padding-all-small auto-height">
                        <div className="return-policy_equipment return-days">
                        
                        </div>
                        <span className="description">
                            {ReactHtmlParser(EQReturnData.ntklist[0].description)}
                        </span>
                        <a className="link-text bold" href="#0" onClick={Open} data-track={EQReturnData.ntklist[0].linktext}>{EQReturnData.ntklist[0].linktext}</a>
                        { " ( " + EQReturnData.ntklist[0].date + " ) "}
                        <img alt="need_to_know" src="/content/dam/verizon/support/consumer/supportservices/vcm-react/media/icon-pdf.png"></img>
                    </div>
                </div>
            </li>
            
        </ul>
    )
}

export default NeedToKnow


// WEBPACK FOOTER //
// ./src/components/modules/NeedToKnow.js